<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="airport.name"
          field-name="name"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="airport.icao"
          field-name="icao"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="airport.city"
          field-name="city"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="airport.country"
          field-name="country"
          rules="required"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="airport.callsign"
          field-name="callsign"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="airport.frequency"
          field-name="frequency"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="airport.traffic_pattern"
          field-name="traffic_pattern"
          rules="required"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="airport.latitude"
          field-name="latitude"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="airport.longitude"
          field-name="longitude"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="airport.altitude"
          field-name="altitude"
          rules="required"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <validated-text-field
          v-model="airport.airport_category"
          field-name="airport_category"
          rules="required"
          type="text"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditAirport',
    props: {
      airport: Object,
    },
  }
</script>
